export type CellBaseRectInput = {
  cellIndex: number;
  boardOriginX: number;
  boardOriginY: number;
  cellSize: number;
};

export type CellBaseRect = {
  row: number;
  col: number;
  left: number;
  top: number;
  centerX: number;
  centerY: number;
  width: number;
  height: number;
};

export type BoardVisualSnapshot = {
  x: number;
  y: number;
  baseX: number;
  baseY: number;
};

export type BoardFeedbackState = {
  activeFeedbackCount: number;
  selectedCellIndex: number | null;
  terminal: boolean;
};

export type BoardFeedbackCleanup = {
  activeFeedbackCount: number;
  selectedCellIndex: null;
  resetCellGeometry: boolean;
  resetMarkers: boolean;
  resetOutlines: boolean;
  terminal: boolean;
};

export function getCellBaseRect(input: CellBaseRectInput): CellBaseRect {
  const row = Math.floor(input.cellIndex / 9);
  const col = input.cellIndex % 9;
  const left = input.boardOriginX + col * input.cellSize;
  const top = input.boardOriginY + row * input.cellSize;

  return {
    row,
    col,
    left,
    top,
    centerX: left + input.cellSize / 2,
    centerY: top + input.cellSize / 2,
    width: input.cellSize,
    height: input.cellSize
  };
}

export function resetBoardVisualSnapshot(snapshot: BoardVisualSnapshot): Pick<BoardVisualSnapshot, 'x' | 'y'> {
  return {
    x: snapshot.baseX,
    y: snapshot.baseY
  };
}

export function getBoardFeedbackCleanup(state: BoardFeedbackState): BoardFeedbackCleanup {
  return {
    activeFeedbackCount: 0,
    selectedCellIndex: null,
    resetCellGeometry: true,
    resetMarkers: true,
    resetOutlines: true,
    terminal: state.terminal
  };
}
